import React from "react";
import { useNavigate } from "react-router-dom";

const Card = ({ error, setFinish, setError }) => {
  const navigate = useNavigate();
  return (
    <div className=" min-w-40 max-w-md w-3/4  h-52 shadow-gray-400  rounded bg-white shadow flex flex-col justify-center gap-6  fixed z-30 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-4">
      <span className=" font-semibold text-lg">
        {error ? (
          <div className="flex flex-col items-center justify-center gap-1">
            {" "}
            <span>عملیات ناموفق بود.</span>
            <span className=" ">لطفا دوباره تلاش کنید.</span>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center gap-1">
            {" "}
            <span>تشکر از شما</span>
            <span className=" ">
              همکاران ما جهت هماهنگی‌ با شما تماس خواهند گرفت.
            </span>
          </div>
        )}
      </span>
      <div className="flex justify-center gap-4 w-full ">
        <button
          className={` 
         text-lg    text-white px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200 ${
           error
             ? "bg-red-500 hover:bg-red-400"
             : "bg-green-600 hover:bg-green-500"
         } 
          `}
          type="submit"
          onClick={() => {
            navigate("/");
          }}
        >
          <span className={` mx-auto `}>تایید</span>
        </button>
        <button
          className={`  
         text-lg   text-gray-800 bg-gray-400  px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200   z-20 hover:bg-buttonGray `}
          type="button"
        >
          <span
            className=" mx-auto"
            onClick={() => {
              setFinish(false);
              setError(false);
            }}
          >
            بازگشت
          </span>
        </button>
      </div>
    </div>
  );
};

export default Card;
